export function isImgElement(element: unknown): element is HTMLImageElement {
  return typeof element === 'object' && (element as HTMLElement | undefined)?.tagName === 'IMG';
}
